import GoogleMap from './google-map';
export default GoogleMap;